import Raven from 'raven-js';
import * as ActionTypes from '../actions/ActionTypes';
import { ERROR_CODES } from '../constants/ApiErrorConstants';
import ImportActionTypes from '../import/actions/ActionTypes';
export default {
  ravenInstance: Raven,
  blacklists: {
    [ActionTypes.FETCH_ARTICLE_DETAILS_ERROR]: {
      statusCodes: [ERROR_CODES.NOT_FOUND]
    },
    [ActionTypes.FETCH_ARTICLE_CONTENT_ERROR]: {
      statusCodes: [ERROR_CODES.NOT_FOUND]
    },
    [ActionTypes.FETCH_ARTICLE_HAS_BUFFERED_CHANGES_ERROR]: {
      statusCodes: [ERROR_CODES.NOT_FOUND]
    },
    [ActionTypes.UPDATE_ARTICLE_ERROR]: {
      statusCodes: [ERROR_CODES.CONFLICT, ERROR_CODES.PRECONDITION_FAILED]
    },
    [ActionTypes.UPDATE_ARTICLE_VISIBILITY_ERROR]: {
      statusCodes: [ERROR_CODES.PRECONDITION_FAILED]
    },
    [ActionTypes.PUBLISH_ARTICLE_ERROR]: {
      statusCodes: [ERROR_CODES.CONFLICT]
    },
    [ActionTypes.CREATE_CATEGORY_ERROR]: {
      statusCodes: [ERROR_CODES.CONFLICT]
    },
    [ActionTypes.CREATE_MULTI_LANGUAGE_CATEGORY_ERROR]: {
      statusCodes: [ERROR_CODES.CONFLICT]
    },
    [ActionTypes.UPDATE_CATEGORY_ERROR]: {
      statusCodes: [ERROR_CODES.CONFLICT]
    },
    [ActionTypes.DELETE_CATEGORY_ERROR]: {
      statusCodes: [ERROR_CODES.NOT_FOUND]
    },
    [ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_ERROR]: {
      statusCodes: [ERROR_CODES.NOT_FOUND]
    },
    [ImportActionTypes.START_OR_CANCEL_IMPORT_ERROR]: {
      statusCodes: [ERROR_CODES.BAD_REQUEST]
    }
  }
};